<template>
  <PlaceholderPantalla
    titulo="Catálogo de Proveedores"
    subtitulo="Gestión de proveedores y relaciones comerciales"
    descripcion="Administra tu catálogo de proveedores con información completa de contacto, productos que suministran, términos de pago, historial de compras, evaluación de desempeño, y análisis de mejores proveedores. Centraliza toda la información para tomar decisiones de compra más informadas."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Catálogo completo de proveedores activos e inactivos',
  'Información de contacto detallada (teléfonos, emails, dirección)',
  'Datos fiscales (RFC, razón social)',
  'Catálogo de productos que suministra cada proveedor',
  'Precios de lista por producto y proveedor',
  'Términos de pago y crédito',
  'Tiempo de entrega promedio',
  'Evaluación de proveedores (calidad, precio, servicio)',
  'Historial completo de compras',
  'Cuentas por pagar pendientes por proveedor',
  'Comparador de precios entre proveedores',
  'Proveedores preferidos y alternos',
  'Notas y comentarios sobre cada proveedor',
  'Documentos adjuntos (contratos, catálogos)',
  'Exportar directorio de proveedores'
]

const datosManejados = [
  'Nombre comercial y razón social',
  'RFC / Datos fiscales',
  'Dirección completa',
  'Teléfonos y contactos',
  'Emails',
  'Sitio web',
  'Persona de contacto principal',
  'Productos que suministra',
  'Precios por producto',
  'Términos de pago (contado, crédito 15, 30 días)',
  'Límite de crédito',
  'Tiempo de entrega',
  'Calificación (1-5 estrellas)',
  'Evaluación de desempeño',
  'Total de compras históricas',
  'Cuentas por pagar actuales',
  'Estado (Activo, Inactivo, Bloqueado)',
  'Notas y observaciones',
  'Documentos adjuntos'
]
</script>
